module.exports = __webpack_public_path__ + "static/img/paymentemptystage.980b1f6.svg";